// services/menu.service.ts
import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor() {}

  getMenuItems(userPermissions: string[]): MenuItem[] {
    let menuItems: MenuItem[] = [];

    menuItems.push({
      label: 'Aktivitäten',
      icon: 'pi pi-list-check',
      routerLink: '/activities',
      escape: false,
    });

    try {
      for (let perm of userPermissions) {
        switch (perm) {
          case 'Lead.Read':
            menuItems.push({
              label: 'Interessent:innen',
              icon: 'pi pi-fw pi-user-plus',
              routerLink: ['/interested'],
            });
            break;
          case 'Participants.Read':
            menuItems.push({
              label: 'Teilnehmer:innen',
              icon: 'pi pi-fw pi-id-card',
              routerLink: ['/participants'],
            });
            break;
          case 'Course.Read':
            menuItems.push({
              label: 'Kurse',
              icon: 'pi pi-book',
              routerLink: '/courses',
            });
            break;
          case 'ToDo.Read':
            menuItems.push({
              label: 'ToDos',
              icon: 'pi pi-fw pi-check-square',
              routerLink: ['/dashboard'],
            });
            break;
        }
      }

      return menuItems;
    } catch (error) {
      return menuItems;
    }
  }
}
